var map = {
	"./clouds.svg": "6a63",
	"./dunes.svg": "fd10",
	"./forest.svg": "22d6",
	"./mist.svg": "2a75",
	"./mountains.svg": "75df",
	"./night.svg": "f0ea",
	"./ocean.svg": "f31d",
	"./sunset.svg": "5ee6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f26c";